import React from 'react'

const NotFound = (props) => (
  <main className='p-y-2'>
    <section className='container text-xs-center'>
      <h1>404</h1>
      <h3>Página não encontrada</h3>
      <button className='button is-primary' onClick={() => props.history.goBack()} >
        Voltar
      </button>
    </section>
  </main>
)

export default NotFound



// WEBPACK FOOTER //
// ./src/routes/NotFound/index.js